/* KANON `Programy v2 - D3 (0.8)` — what a CLIENT'S PLAN row adds to the shared anatomy.
 *
 * Everything it has in common with a template row is in `listRow.module.css`. What is here is the
 * leading avatar column, the extra 11px of height it buys, where the progress bar stands under the
 * sub-line and the percent in the last track.
 *
 * Read off the rendered specimen at 1512×1000, then re-cut a fifth taller by owner decision D28 of
 * 4 September 2026:
 *   row      grid `42px 61px minmax(0,1fr) auto 48px`, height 86
 *            (canon: `35px 51px minmax(0,1fr) 86.5px 83px`, height 72 — `ROW_D + 11`)
 *   avatar   38 inside a 42px track, centred — the canon's 32-in-35 on the same fifth
 *   bar      `shared/ui/progressBar` (6px, --bg-sunken, --accent), 4 under the sub-line, max 136
 *   percent  13 / 700 / --text-2, tabular, flush right
 *
 * The mode track is `auto` since the owner's polish of 4 November 2026: it holds the 16px mark, and
 * `Wstrzymany` before it on a paused plan. The workout fraction that needed 108px left the row. The
 * last track stays a fixed 48, so the percent keeps one right edge and the marks one x.
 *
 * Heights and widths are layout rather than design tokens (see stylelint.config.js); every colour,
 * space, radius and type value below is a token. */

.row {
  grid-template-columns: 42px var(--w-pl-cover) minmax(0, 1fr) auto 48px;
  height: var(--h-pl-row-client);
}

/* A 42px track holding a 38px disc: the canon's 35-and-32 pair on D28's fifth, and the disc is
 * centred in it rather than flush, so the covers beside it keep one left edge across both scopes.
 *
 * `--sz-avatar` is `shared/ui/AvatarChip`'s own seam — the diameter, and nothing else about the
 * disc, is what a surface may state. See that module's header. */
.avatarCell {
  --sz-avatar: var(--sz-pl-row-avatar);

  display: flex;
  align-items: center;
  justify-content: center;
}

/* The bar is the LAST child of the shared `.identity` column, which sets the gap between the name
 * and the sub-line; the extra 4px here is the specimen's own `marginTop` and is what separates a
 * measurement from a line of text. Its look is `shared/ui/progressBar`'s; its place is this row's. */
.bar {
  width: 100%;
  max-width: 136px;
  margin-top: var(--space-1);
}

.progress {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.percent {
  flex: none;
  font-size: var(--type-control);
  font-weight: var(--fw-bold);
  line-height: var(--lh-auto);
  color: var(--text-2);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
